import { render, staticRenderFns } from "./alacakyaslandirma.vue?vue&type=template&id=f8e8ecc2"
import script from "./alacakyaslandirma.vue?vue&type=script&lang=js"
export * from "./alacakyaslandirma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports